module.exports = __webpack_public_path__ + "img/metamask-fox.c879a582.svg";